export interface CuerpoOposicion {
  id: string;
  label: string;
  shortLabel: string;
  icon: string;
  description: string;
  requiresCCAA: boolean;
  /** Plan code (Stripe) que activa el acceso premium a este cuerpo */
  planCode?: string;
  /** Si está disponible en producción (false = "próximamente") */
  available: boolean;
}

/**
 * Catálogo de cuerpos de oposición soportados.
 * El `id` se guarda en `profiles.opositor_body` (texto libre, sin enum).
 * Para añadir un nuevo cuerpo: solo añadir aquí. La UI de registro lo recoge automáticamente.
 */
export const CUERPOS_OPOSICION: CuerpoOposicion[] = [
  {
    id: 'secretaria',
    label: 'Secretaría-Intervención',
    shortLabel: 'Secretaría-Intervención',
    icon: '🏛️',
    description: 'Administración local',
    requiresCCAA: true,
    planCode: 'oposiciones',
    available: true,
  },
  {
    id: 'c1',
    label: 'C1 — Cuerpo General Administrativo del Estado',
    shortLabel: 'C1 Admin. Estado',
    icon: '🇪🇸',
    description: 'Cuerpo General Administrativo (nacional)',
    requiresCCAA: false,
    planCode: 'oposiciones_c1',
    available: true,
  },
  {
    id: 'c2',
    label: 'C2 — Auxiliar Administrativo del Estado',
    shortLabel: 'C2 Auxiliar Estado',
    icon: '📋',
    description: 'Auxiliar Administrativo (nacional)',
    requiresCCAA: false,
    available: true,
  },
  {
    id: 'guardia_civil',
    label: 'Guardia Civil',
    shortLabel: 'Guardia Civil',
    icon: '🛡️',
    description: 'Cuerpo de Seguridad del Estado',
    requiresCCAA: false,
    available: true,
  },
  {
    id: 'ayudante_iipp',
    label: 'Ayudante de Instituciones Penitenciarias',
    shortLabel: 'Ayudante II.PP.',
    icon: '🔑',
    description: 'Cuerpo de Ayudantes de IIPP (nacional)',
    requiresCCAA: false,
    available: true,
  },
  {
    id: 'policia_nacional',
    label: 'Policía Nacional',
    shortLabel: 'Policía Nacional',
    icon: '👮',
    description: 'Cuerpo Nacional de Policía (Escala Básica)',
    requiresCCAA: false,
    available: true,
  },
  {
    id: 'generico',
    label: 'Base Común (Oposición General)',
    shortLabel: 'Base Común',
    icon: '📚',
    description: 'Legislación y materias comunes a todas las oposiciones',
    requiresCCAA: false,
    available: true,
  },
];

export function getCuerpoById(id: string): CuerpoOposicion | undefined {
  return CUERPOS_OPOSICION.find((c) => c.id === id);
}
